import { useLocation } from "@tanstack/react-router"
import { useCallback } from "react"

const KEY = "redirectAfterLogin"
const DEFAULT = "/dashboard"

const clearRedirectUrl = () => {
  sessionStorage.removeItem(KEY)
}

const getRedirectUrl = () => {
  const url = sessionStorage.getItem(KEY)
  if (!url) {
    return DEFAULT
  }

  clearRedirectUrl()

  return url
}

export default () => {
  const href = useLocation({
    select: (location) => location.href,
  })

  const setRedirectUrl = useCallback(
    (customUrl?: string) => {
      if (!sessionStorage.getItem(KEY)) {
        sessionStorage.setItem(KEY, customUrl ?? href)
      }
    },
    [href],
  )

  return { getRedirectUrl, setRedirectUrl, clearRedirectUrl }
}
